import { BasePlayerEvent } from '../../../reporter/constants';
import { MonitoredMediaEvents } from '../constants';
import { PlayerEventReporter } from './interfaces';

const { code } = MonitoredMediaEvents.volumechange;

export default function volumechangeHandler(
  event: BasePlayerEvent,
  reporter: PlayerEventReporter
): boolean {
  if (event.e != code) {
    return false;
  }
  if (typeof event.mute === 'undefined') {
    return true;
  }
  const mute = reporter.localState.event.mute;
  reporter.localState.event.mute = event.mute;
  return mute === event.mute;
}
